export default __webpack_public_path__ + "static/media/grafema_ummi_11.4a4e653b.jpg";